<template>
  <div>
    <div class="bg-white load-ar">
        <!--表格-->
        <div >
          <el-table
            class="table-inquiry"
            :data="list"
            ref="tableRef"
            :cell-style="{whiteSpace: 'pre-wrap'}"
            :height="list.length >6 ? `calc( 100vh - 300px )` : list.length * 110+50 + 'px'"
             :span-method="objectSpanMethod"
            border
            style="width: 100%">
          <!--表单内容-->
          <el-table-column v-for="(item,index) in checkDetail()" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" :sortable="item.sortable" :resizable="false">
            <!-- 自定义表头 -->
            <template slot="header" slot-scope="scope">
              <span>{{ scope.column.label }}</span>
              <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
            </template>
            <template slot-scope="scope">
              <!--订单报价-->
              <div :class="{'text-center':item.center}"   v-if="item.pattern==='store_list'" class="text-ell">
                <!--住宿订单-->
                <div v-if="scope.row.order_type==1" class="text-ellipsis">
                    <div class="room-type">
                        <div class="room-list">
                            <template v-for="(item,index) in scope.row.room_need_arr.list">
                                <div  :key="index" class="room-item" v-if="index<2">
                                    <template v-for="(room,room_index) in item.offer_info">
                                        <div  :key="room_index" v-if="room_index<3">
                                            <span class="room-img">
                                                <img :src="`/images/fx/icon_${room.type}.png`" class=" cursor-pointer mr-1"  >
                                            </span>
                                            <span>{{room.type| formatVar('roomStyle')}}</span>
                                            <span class="room-num">{{room.room_num}}间</span> 
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="text-center" style="height: 8px; line-height: 8px; color:#999;margin-top: -6px; " v-if="scope.row.room_need_arr.list.length>2||scope.row.room_need_arr.list[0].offer_info.length>2">...</div>
              </div>
            <!--入离时间-->
            <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='date_in'">
                <div class="flex " v-if="scope.row.order_type==1">
                    <div>
                        <div>
                            <span class="el-icon-room">入：</span>
                            <span class="date-tiem datein"><span >{{scope.row.date_in | formatTimestamp(2)}}</span> </span>
                        </div>
                        <div class="mt-2">
                            <span class="el-icon-room">离：</span>
                            <span class="date-tiem datein"> <span>{{scope.row.date_out | formatTimestamp(2)}}</span> </span>
                        </div>
                    </div>
                </div>
                <!--纯会订单-->
                <div v-else >
                    <template v-for="(item,index) in scope.row.meeting_need_arr.list">
                        <div  :key="index" v-if="index<1" class="text-ellipsis">
                            <div>
                                <div>
                                    <span class="el-icon-room"><i class="el-icon-date"></i>开会日期：</span>
                                    <span class="date-tiem"><span class="datein">{{item.date | formatTimestamp(2)}}</span></span>
                                </div>
                                <div class="mt-2 flex-left">
                                    <span class="el-icon-room"><i class="icon-geren iconfont"></i>出席人数：<span class="date-tiem">{{item.num}} 人</span> </span>  
                                </div>
                            </div>
                            <div  class="ml-4">
                                <div>
                                    <span class="el-icon-room"><i class="icon-shijian iconfont"></i>时&ensp;间&ensp;段：</span>
                                    <span class="date-tiem min-wdei"><span >{{item.timeslot| formatVar('TimeSlots')}}</span></span>
                                </div>
                                <div class="mt-2">
                                    <span class="el-icon-room"><i class="icon-mianji2 iconfont"></i>要求面积：<span class="date-tiem">{{item.area}} ㎡</span> </span>  
                                </div>
                            </div>
                            <div  class="ml-4">
                                <div>
                                    <span class="el-icon-room"><i class="icon-qitafuwu iconfont"></i>布&emsp;&nbsp;局：</span>
                                    <span class="date-tiem"><span >{{item.type | formatVar('LayoutTypes')}}</span></span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!--人数-->
            <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='num'">
                <div class="flex ">
                    <div class="mt-2">
                        <span class="el-icon-room"><span class="date-tiem">{{scope.row.num}} 人</span> </span>
                    </div>
                    <div class="mt-2 dlis">
                        <span class="datein text-fw">{{((scope.row.date_out - scope.row.date_in)/86400).toFixed(0)}}</span> 晚
                    </div>
                </div>
            </div>
              <!--订单类型-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='order_type'">
                <span class="text-psis mr-2 text-confirm" v-if="scope.row.appoint_store_id*1>0">
                    定向
                </span>
                <span class="text-psis" :class="{ 'text-man':scope.row.order_type==1,'text-woman':scope.row.order_type==2 }">
                      {{ scope.row[item.prop]==1?'住宿订单':'纯会订单'}}
                </span>      
              </div>
                <!--团号-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='title'" class="travel_title">
                    <img  src="/images/public/logo.png" style="width: 64px;height: 64px" class="hotel-img">
                    <div class="">
                        <span>{{ scope.row.travel_title }}</span>
                        <p>{{scope.row[item.prop]}}   </p>
                    </div> 
              </div>
              <!--时间-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
              <!-- 已有报价-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='offer_count'">
                <span v-if="scope.row[item.prop]==0">暂无</span>
                <span v-else><span class="hotel">{{scope.row[item.prop]}}</span>家酒店</span>
              </div>
              <!-- 待报价-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='hotelQuote'">
                <span class="hotel" v-if="scope.row[item.prop]">{{ scope.row[item.prop].length}}</span>家酒店
              </div>
                <!--状态-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='quoted_status'">
                    <span class="status_1">已报价</span>
                </div>
                <!--状态-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='review_status'">
                    <span class="status_1">{{scope.row.status | formatVar('TOrderStatus')}}</span>
                </div>
              <!--其他-->
              <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
            <!--操作按钮-->
            <el-table-column
              fixed="right"
              header-align="center"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <div class="text-center ">
                  <el-button  @click="checkMatch(scope.row)" type="text" size="small" v-if="isAdmin&&!review">查看匹配</el-button>
                  <el-button  @click="goForDetail(scope.row)" type="text" size="small" v-if="userInfo.type!=3||quoted">订单详情</el-button>
                  <el-button  @click="popUpQuote(scope.row.hotelQuote)" type="text" size="small" v-if="userInfo.type==3&&!quoted">去报价</el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
    <!--弹出待报价酒店列表-->
    <el-dialog
      title="请选择要报价的酒店"
      :visible.sync="dialogVisible2"
      width="600px">
        <ul class="list-unstyled">
            <li v-for="(item,index) in hotelQuote" :key="index" :class="{'text-active':selectedIndex==index}" @click="selectedIndex=index">
                {{item.hotel_title}}
                <i class="el-icon-check check-icon" v-if="selectedIndex==index"></i>
            </li>
        </ul>
        <div class="list-bttom">
            <el-button  @click="dialogVisible2 = false;selectedIndex=0;">取消</el-button>
            <el-button type="primary" @click="goForDetail(hotelQuote[selectedIndex])">确定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
 import { mapGetters,mapState,mapActions } from 'vuex'
 import { debounce } from "lodash";
    export default {
    name: 'ReportList',
    components: {},
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        //是否是已报价列表
        quoted: {
            type: Boolean,
            default: false,
        },
        //是否是待审核列表
        review: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tableData:[ 
                {name:'发布时间',prop:'add_time',width:180,center:true,pattern:'time'},
                {name:'订单号',prop:'oid',width:140,center:true,},
                {name:'团号',prop:'title', minWidth:200,center:true},
                {name:'订单类型',prop:'order_type', minWidth:200,center:true,pattern:'order_type'},
                {name:'询价城市',prop:'city_name', minWidth:100,center:true},
                {name:'入离时间',prop:'store_list',center:true, minWidth:160,pattern:'date_in'},
                {name:'人数/晚数',prop:'store_list',center:true, minWidth:80,pattern:'num'},
                {name:'房型/间数',prop:'store_list', minWidth:400,pattern:'store_list'},
                {name:'已有报价',prop:'offer_count', minWidth:100,center:true,pattern:'offer_count'},
            ],
            tableData2:[ 
                {name:'发布时间',prop:'add_time',width:180,center:true,pattern:'time'},
                {name:'订单号',prop:'oid',width:140,center:true},
                {name:'采购商/团号',prop:'title', minWidth:300,center:true,pattern:'title'},
                {name:'订单类型',prop:'order_type', minWidth:200,center:true,pattern:'order_type'},
                {name:'入离时间',prop:'store_list',center:true, minWidth:160,pattern:'date_in'},
                {name:'人数/晚数',prop:'store_list',center:true, minWidth:80,pattern:'num'},
                {name:'房型/间数',prop:'store_list', minWidth:400,pattern:'store_list'},
                {name:'待报价',prop:'hotelQuote', minWidth:100,center:true,pattern:'hotelQuote'},
            ],
            dialogVisible2: false,
            //待报价酒店列表
            hotelQuote: [],
            //选中的酒店index
            selectedIndex: 0,
        };
    },
    computed: {
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
        
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.order_type === 2 && columnIndex === (this.storeInfo.type==3?4:5)) {
            // 起始单元格：行1，跨4列
            return {    
                rowspan: 1,
                colspan: 3
            }
            }
            // 后面3列（索引2、3、4）隐藏
            let hideColumns = [6,7];
            if(this.storeInfo.type==3){
                hideColumns = [5,6];
            }
            if (row.order_type === 2 && hideColumns.includes(columnIndex)) {
            return {
                rowspan: 0,
                colspan: 0
            }
            }
            // 默认不合并
            return {
            rowspan: 1,
            colspan: 1
            }
        },
        //返回对应的表格数据
        checkDetail(){
            switch (this.userInfo.type) {
                case 2:
                case 99:
                    if(this.review){
                        this.tableData[6].name = '状态';
                        this.tableData[6].pattern = 'review_status'; 
                    }
                    return this.tableData;
                case 3:
                    if(this.quoted){
                        this.tableData2[5].name = '状态';
                        this.tableData2[5].pattern = 'quoted_status'; 
                    }
                    return this.tableData2;
                case '待推送':
                    return this.OrderNumInfo.status_3;
                default:
                    return 0;
            }
        },
        //点击待报价酒店
        popUpQuote(hotelQuote){
            //如果只有一个酒店，直接报价
            this.hotelQuote = hotelQuote;
            if(hotelQuote.length==1){
                this.selectedIndex = 0;
                this.goForDetail(hotelQuote[0]);
            }else{
                //如果有多个酒店，弹出选择框
                this.dialogVisible2 = true;
            }
        },
        /*跳转查看订单详情页*/
        goForDetail(item) {
            console.log(item);
            let cardItem =item;
            this.$router.push({
                name: 'OrderDetail',
                query: {
                    orderId: cardItem.oid,
                    match_store_id: cardItem.match_store_id,
                }
            });
            // window.open(routeUrl.href, '_blank');
        },
        /*查看匹配*/
        checkMatch(item){
            this.$router.push({
            name: 'OrderMatchResult',
            query: {
                orderId: item.oid,
                storeType: 3,
            }
            });
            // window.open(routeUrl.href, '_blank');
        },
        },
    };
</script>

<style lang="scss" scoped>
    .load-ar{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .text-psis{
        background-color: #f5f6f9;
        color: #6e7789;
        padding: 6px 8px;
        border-radius: 4px;
        font-size: 12px;
    }
    .text-man{
        background-color: var(--smtc-color-primary);
        color: var(--smtc-color-white);
    }
    .text-woman{
        background-color: var(--smtc-color-warning);
        color: var(--smtc-color-white);
    }
    .text-sm{
        background-color: var(--smtc-color-text-back);
        color: var(--smtc-color-white) !important;
    }
    .text-confirm{
        background-color: var(--smtc-color-text-paleRed);
        color: var(--smtc-color-white) !important;
    }
    .text-ellipsis{
        display: flex;
        justify-content: left;
        margin-bottom: 10px;
        justify-content: center;

    }
    .date-tiem{
        background-color: #f5f5f5;
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 12px;
    }
    .room-item{
        display: flex;
        margin-bottom: 0.5rem;
        >div{
            // background-color: #f5f5f5;
            padding:4px 8px;
            margin-right: 1rem;
            width: 140px;
            text-align: center;
            border-radius: 4px;
            font-size: 10px;
            display: flex;
            &:last-child{
                margin-right: 0;
            }
        }
        &:last-child{
            margin-bottom: 0;
        }

    }

    .room-type{
        margin-left: 1rem;
        font-size: 12px;
        display: flex;
    }
    .el-icon-room{
        margin-top: 8px;
        font-size: 12px;
        i{
            margin-right: 4px;
            font-size: 12px;
        }
    }
    @media (max-width:2100px){
        .room-list div:nth-child(3){
            display: none;
        }
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }
    .travel_title{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: left !important;
        img{
            margin-right: 10px;
        }
        span{
            font-weight: bold;
        }
        p{
            font-size: 12px;
            background-color: #f5f5f5;
            padding:2px 8px;
            margin-top: 2px;
        }
    }
    .hotel{
        font-weight: bold;
        color: var(--smtc-color-text-red);
        margin-right: 2px;
    }   
    .list-unstyled{
        li{
            background-color: #f5f5f5;
            padding: 10px 20px;
            margin-bottom: 10px;
            border-radius: 4px;
            text-align: left;
            cursor: pointer;
        }
        .text-active{   
            color: var(--smtc-color-primary);
            position: relative;
            
        }
        .text-active::after{
            content: '';
            position: absolute;
            bottom: 25%;
            left: 10px;
            width: 2px;
            height: 50%;
            background-color: var(--smtc-color-primary);
            border-radius: 0 0 4px 4px;
        }
    }
        
    .list-bttom{
        margin-top: 20px;
    }
    .check-icon{
        float: right;
        font-size: 16px;
        font-weight: bold;
    }
    .datein{
        color: var(--smtc-color-primary);
    }
    .min-wdei{
        min-width:28px;
        display: inline-block;
        padding: 0 10px;
    }
    .status_1{
        background-color:#fae7eb;
        color: #e46269;
        display: inline-block;
        width: 60px;
        padding: 2px 0;
        font-size: 12px;
        border-radius: 4px;
    }
    .room-img{
        width: 20px;
        border-right: 2px solid #f7f7f9;
        padding-right: 2px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        img{
            width: 100%;
        }
    }
    .room-num{
        margin-left:auto ;
    }
    .dlis{
        font-size: 12px;
    }
    .flex-left{
        display: flex;
    }
    .text-fw{
        font-weight: bold;
    }
</style>
<style>
    .table-inquiry .has-gutter th,.table-inquiry th.el-table__cell{
        background: #f7f7f9;
        color: #333;
    }
</style>
